<template>
  <div class="form-group">
    <label for="file-input" class="d-block"> {{ title }} </label>
    <div class="fileUpload">
      <div class="row">
        <div class="col-11 p-0">
          <div
            class="fileUpload__list"
            :class="{ invalid: showfileCountErorr }"
          >
            <div
              class="custom__tag"
              v-for="(item, index) in supportedFiles"
              :key="index"
            >
              <span>
                {{ item.name.split(".")[0] }}
              </span>
              <a class="delete" @click.prevent="removeAttachment(index)">
                &times;
              </a>
            </div>
          </div>
        </div>
        <div class="col-1 p-0">
          <label for="file-input">
            إرفاق ملف
            <input
              multiple
              type="file"
              @click="onInputClick($event)"
              @change="handleFileUploads($event)"
              id="file-input"
            />
          </label>
        </div>
      </div>
    </div>
    <small class="text-danger" v-if="showfileCountErorr">
      لابد من رفع مرفق على الاقل
    </small>
  </div>
</template>

<script>
import { fileUploadValidation } from "@/helpers/fileUploadValidation";

export default {
  name: "FileUpload",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
 data: () => {
    return {
      supportedFiles: [],
      deletedFiles: [],
      showfileCountErorr: false,
    };
  },
  computed: {
    inputState() {
      return this.supportedFiles.length;
    },
  },
  methods: {
    setFiles(files) {
      this.supportedFiles = files;
    },
    onInputClick(event) {
      event.target.value = "";
    },
    async handleFileUploads(event) {
      const response = await fileUploadValidation(event);
      this.supportedFiles = [...this.supportedFiles, ...response];
      this.$emit("FilesChanged", this.supportedFiles);
      if (this.showfileCountErorr) this.showfileCountErorr = false;
    },
    removeAttachment(index) {
      const item = this.supportedFiles[index];
      if (item.value && typeof item.value === "string")
        this.deletedFiles.push(item);
      this.supportedFiles.splice(index, 1);
      this.$emit("FilesChanged", this.supportedFiles);
      if (!this.inputState) this.showfileCountErorr = true;
    },
  },
};
</script>

<style scoped>
@import "./_fileupload.scss";
</style>
